import React from "react"
import styles from "./FeedbackFormSuccess.module.scss"
import { DIALOG_OPERATION_FEEDBACK_FORM_CONST } from "../../DialogOperatorFeedbackForm.const"
import { useTranslation } from "react-i18next"
import { ReactComponent as RobotIconSuccess } from "../../../../../assets/images/feedback-form/robot-success.svg"

const { tNamespace, tPaths, testIds } = DIALOG_OPERATION_FEEDBACK_FORM_CONST

const FeedbackFormSuccess = () => {
    const { t } = useTranslation(tNamespace)

    return (
        <div className={styles.success}>
            <div className={styles.success__text}>{t(tPaths.successSuggestion)}</div>
            <RobotIconSuccess className={styles.success__robot} data-testid={testIds.robotSuccess} />
        </div>
    )
}

export default FeedbackFormSuccess
